import type { CMSAssetDashboardActivity } from '../types';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { CMS_API_ROOT_URL } from '../constants';

export const CMS_ASSET_DASHBOARD_STATS_QUERY_KEY = 'cmsAssetDashboardStatsQueryKey';

interface DashboardActivityResponse {
  data: CMSAssetDashboardActivity[];
  pagination: {
    totalPages: number;
    currentPage: number;
    rowsPerPage: number;
    totalCount: number;
  };
  sort: {
    field: string;
    order: string;
  };
}

const getDashboardActivity = (
  sortBy: string,
  sortOrder: string,
  rowsPerPage: number,
  currentPage: number,
): Promise<DashboardActivityResponse> => {
  const url = `${CMS_API_ROOT_URL}/assets/activity?sortBy=${sortBy}&sortOrder=${sortOrder}&rowsPerPage=${rowsPerPage}&currentPage=${currentPage}`;
  return FetchPromise.get(url);
};

export const useGetDashboardActivity = (sortBy: string, sortOrder: string, rowsPerPage: number, currentPage: number) =>
  useQuery<DashboardActivityResponse, JQuery.jqXHR>({
    queryKey: [CMS_ASSET_DASHBOARD_STATS_QUERY_KEY, currentPage, rowsPerPage, sortBy, sortOrder],
    queryFn: () => getDashboardActivity(sortBy, sortOrder, rowsPerPage, currentPage),
  });
